export default __webpack_public_path__ + "static/media/kitchen_1_image.3a6abe3e.jpg";